import React from 'react';
import { formatDollar } from '../../../helpers/utils';
const Row = ({
  location,
  own,
  accent_color,
  display_dollar_amount
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `list-row list-item ${location.ranking === (own === null || own === void 0 ? void 0 : own.ranking) && 'list-item-own'}`,
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, location.ranking, "."), " ", location.name), /*#__PURE__*/React.createElement("div", {
    className: "count"
  }, location.count ? /*#__PURE__*/React.createElement("div", null, location.count) : '-'), display_dollar_amount && /*#__PURE__*/React.createElement("div", {
    className: "amount"
  }, location.sales ? /*#__PURE__*/React.createElement("div", null, `${formatDollar(location.sales, 2)}`) : '-'));
};
export default Row;